var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:("left " + _vm.addClass),attrs:{"href":_vm.redirectSrc,"aria-label":"Logo"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.imgSrc,"alt":""}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26193e69","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/image-logo.vue
// module id = /WDg
// module chunks = 0